import React, { useId } from "react"
import Checkbox from "@kit/design/checkbox"

/**
 * @deprecated
 */
export function CheckboxField({ id, label, ...props }) {
  id = useId(id)
  return (
    <div className="flex items-center">
      <Checkbox id={id} name={name} {...props} />
      <label className="ml-2 mb-0 font-sans" htmlFor={id}>
        {label}
      </label>
    </div>
  )
}
